import { useMemo } from 'react'
import { useAuth } from './use-auth'
import type { PermissionKey } from '@/types/permission'

export function usePermissions() {
  const { user, isLoading: isAuthLoading } = useAuth()

  const permissions = useMemo(() => user?.permissions ?? [], [user])
  const isSuper = user?.isSuper ?? false

  const permissionSet = useMemo(() => new Set(permissions), [permissions])

  const hasPermission = (permission: PermissionKey): boolean => {
    if (isSuper) return true

    return permissionSet.has(permission)
  }

  const hasAnyPermission = (perms: PermissionKey[]): boolean => {
    if (isSuper) return true

    return perms.some((p) => permissionSet.has(p))
  }

  const hasAllPermissions = (perms: PermissionKey[]): boolean => {
    if (isSuper) return true

    return perms.every((p) => permissionSet.has(p))
  }

  return {
    permissions,
    isSuper,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isLoading: isAuthLoading,
  }
}
